// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36YGY","toggleWrap":"styles_toggleWrap__3C0om","content":"styles_content__1G2Xz","selectAreaCode":"styles_selectAreaCode__1Xs6z"};